const DATE_FORMAT = 'DD-MM-YYYY';
const TIME_FORMAT = 'HH:mm';

export const DATE_FORMATS = {
  date: DATE_FORMAT,
  time: TIME_FORMAT,
  dateTime: `${DATE_FORMAT} ${TIME_FORMAT}`,
};
